class LqdInteractiveTextImageHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);

    this.handleDestroy();

    this.initMousePos();
    this.initActiveOnHover();

  }

  getDefaultSettings() {
    return {
      selectors: {
        mousePosEl: '[data-lqd-mouse-pos]',
        activeOnHoverEl: '[data-active-onhover]',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $mousePosEl: this.$element.find(selectors.mousePosEl),
      $activeOnHoverEl: this.$element.find(selectors.activeOnHoverEl),
    }
  }

  initMousePos() {

    this.elements.$mousePosEl.liquidMousePos();

  }

  initActiveOnHover() {

    this.elements.$activeOnHoverEl.liquidSetActiveOnhover();

  }

  onDestroy() {

    this.handleDestroy();

    super.onDestroy();

  }

  handleDestroy() {

    this.handleMousePosDestroy();
    this.handleActiveOnHoverDestroy();

  }

  handleMousePosDestroy() {

    if ( ! this.elements.$mousePosEl.length ) return;

    const mousePosData = this.elements.$mousePosEl.data('plugin_liquidMousePos');

    if ( mousePosData ) {
      mousePosData.destroy();
    }

  }

  handleActiveOnHoverDestroy() {

    if ( ! this.elements.$activeOnHoverEl.length ) return;

    const activeOnHoverData = this.elements.$activeOnHoverEl.data('plugin_liquidSetActiveOnhover');

    if ( activeOnHoverData ) {
      activeOnHoverData.destroy();
    }

  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdInteractiveTextImageHandler, { $element } );
};